var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.655,88.273H341.333v335.448h132.322c21.177,0,38.345-17.167,38.345-38.345V126.618 C512,105.44,494.833,88.273,473.655,88.273z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 88.277,
    style: {
      fill: "#41479B"
    },
    width: 170.67,
    height: 335.45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M38.345,88.273C17.167,88.273,0,105.44,0,126.618v258.759c0,21.177,17.167,38.345,38.345,38.345 h132.322V88.273H38.345z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M85.689,227.025c-13.341,0-24.776-8.038-29.814-19.519c-0.003,0.175-0.052,0.338-0.052,0.513 c0,16.494,13.372,29.866,29.866,29.866s29.865-13.372,29.865-29.866c0-0.175-0.049-0.338-0.052-0.512 C110.464,218.987,99.029,227.025,85.689,227.025z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9CF02"
    },
    cx: 85.69,
    cy: 199.877,
    r: 21.72
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M72.114,159.15c0,7.497,6.078,13.575,13.575,13.575s13.575-6.078,13.575-13.575 c0-5.43-3.394-6.109-3.394-8.145s2.036-4.751-2.036-8.145c2.036,3.394-1.357,4.073-1.357,7.466s1.357,3.394,1.357,6.109 c0,1.5-1.216,2.714-2.714,2.714c-1.5,0-2.714-1.216-2.714-2.714c0-2.714,2.714-5.43,2.714-9.503c0-4.073-0.679-5.43-2.714-8.824 c-2.036-3.394-5.43-6.109-2.714-8.824c-4.073,1.357-2.036,6.787-2.036,10.182c0,3.394-2.714,5.43-2.714,9.503 c0,4.073,2.036,4.751,2.036,7.466c0,1.5-1.216,2.714-2.714,2.714s-2.714-1.216-2.714-2.714c0-2.714,1.357-2.714,1.357-6.109 s-3.394-4.073-1.357-7.466c-4.073,3.394-2.036,6.109-2.036,8.145C75.508,153.041,72.114,153.719,72.114,159.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M25.959,245.557v125.838c0,1.238,1.004,2.241,2.241,2.241h22.667c1.238,0,2.241-1.004,2.241-2.241 V245.557c0-1.238-1.004-2.241-2.241-2.241H28.2C26.963,243.315,25.959,244.319,25.959,245.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M118.27,245.557v125.838c0,1.238,1.004,2.241,2.241,2.241h22.667c1.238,0,2.241-1.004,2.241-2.241 V245.557c0-1.238-1.004-2.241-2.241-2.241h-22.667C119.273,243.315,118.27,244.319,118.27,245.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M58.539,267.276v6.377c0,1.238,1.004,2.241,2.241,2.241h49.817c1.238,0,2.241-1.004,2.241-2.241 v-6.377c0-1.238-1.004-2.241-2.241-2.241H60.78C59.542,265.035,58.539,266.039,58.539,267.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M58.539,343.297v6.377c0,1.238,1.004,2.241,2.241,2.241h49.817c1.238,0,2.241-1.004,2.241-2.241 v-6.377c0-1.238-1.004-2.241-2.241-2.241H60.78C59.542,341.056,58.539,342.059,58.539,343.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M62.585,243.315h46.208c1.137,0,1.551,1.497,0.577,2.082l-21.95,13.171 c-1.065,0.639-2.396,0.639-3.459,0l-21.952-13.171C61.034,244.812,61.449,243.315,62.585,243.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M62.585,357.347h46.208c1.137,0,1.551,1.497,0.577,2.082l-21.952,13.17 c-1.065,0.639-2.396,0.639-3.459,0l-21.951-13.171C61.034,358.843,61.449,357.347,62.585,357.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M88.341,281.537c-0.856-0.082-1.685-0.259-2.562-0.259c-14.931,0-27.078,12.147-27.078,27.078 c0,8.862,4.329,16.662,10.943,21.583c0.761,0.566,1.767-0.252,1.397-1.127c-0.793-1.879-1.239-3.938-1.239-6.106 c0-8.825,7.193-16.002,16.026-15.975c4.643,0.014,9.094-2.279,11.149-6.443C101.228,291.677,96.041,283.118,88.341,281.537z  M85.779,299.42c-2.99,0-5.416-2.424-5.416-5.416c0-2.99,2.425-5.415,5.416-5.415c2.99,0,5.415,2.424,5.415,5.415 C91.193,296.996,88.769,299.42,85.779,299.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M101.912,286.772c-0.761-0.566-1.767,0.253-1.397,1.127c0.794,1.879,1.239,3.938,1.239,6.105 c0,8.826-7.194,16.003-16.026,15.976c-4.643-0.014-9.095,2.279-11.149,6.443c-4.249,8.612,0.938,17.172,8.638,18.751 c0.856,0.082,1.685,0.259,2.562,0.259c14.93,0,27.078-12.147,27.078-27.078C112.855,299.494,108.526,291.694,101.912,286.772z  M85.779,328.122c-2.99,0-5.416-2.424-5.416-5.416c0-2.99,2.425-5.415,5.416-5.415c2.99,0,5.415,2.424,5.415,5.415 C91.193,325.697,88.769,328.122,85.779,328.122z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/mn.4f6a95be8bbe7957b2b4f0c3b5aca7f3.svg";
export { ForwardRef as ReactComponent };